<template>
  <b-card no-body class="w-100">
    <div class="d-inline-flex align-items-center w-100 py-5">
      <div class="pl-5 pr-4">
        <font-awesome-icon icon="file-excel" class="display-4 text-excel" />
      </div>

      <div class="w-100 justify-content-center">
        <h4 class="d-inline-flex h3 font-weight-600 mb-0">
          {{ file?.name }}
          <span class="text-gray mx-2">·</span>
          <b-badge class="flex-shrink-0 bg-excel bg-excel-5" pill>
            <font-awesome-icon icon="download" class="mr-1 text-excel" />
            <span
              class="small-text text-excel font-weight-500"
              v-text="formatBytes(file?.size)"
            />
          </b-badge>
        </h4>

        <div class="text-gray">
          Será enviado quando você salvar a oportunidade.
        </div>
      </div>
    </div>

    <b-card-footer class="py-3 d-inline-flex w-100">
      <span class="ml-auto" />
      <b-button
        size="sm"
        variant="outline-danger"
        class="flex-shrink-0 align-self-center mr-0"
        :disabled="disabled"
        @click="$emit('cancel')"
      >
        Cancelar
      </b-button>

      <div class="vr mx-3 text-gray" />

      <b-button
        size="sm"
        variant="outline-default"
        class="flex-shrink-0 align-self-center"
        :disabled="disabled"
        @click="$emit('replace')"
      >
        <font-awesome-icon icon="arrows-rotate" />
        Trocar arquivo
      </b-button>
    </b-card-footer>
  </b-card>
</template>

<script>
import { defineComponent } from "vue";
import { formatBytes } from "@/helpers/functions/NumberHelpers";

export default defineComponent({
  props: {
    file: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["cancel", "replace"],
  setup() {
    return { formatBytes };
  },
});
</script>

<style scoped lang="scss">
.small-text {
  font-size: 0.625rem;
}
</style>
